<template>
    <div class="container-fluid">
        <p class="welcome"></p>
         <div class="col-lg-12 col-sm-12 pt-3 dashboard-page">             
              <div class="col-lg-6 col-sm-6 pt-3">
                <div @click="go_back()" style="cursor:pointer" class="font-weight-normal back-button mb-4"> 
                    Back
                </div>
                <div class="dashboard-inner-new">
                    <div class="panel-title mt-4">
                        <p class="ptitle"> <i class="fa-solid fa-phone text-danger"></i> Airtime Top Up</p>
                    </div>
                    <div class="payment-method purchase-switcher">
                        <label for="" class="payment-label">Switch Purchase Type</label>
                        <select class="payment-input purchase-select" v-model="purchase_mode" @change="switchPurchaseType">
                            <option value="airtime">Airtime Purchase</option>
                            <option value="data">Data Purchase</option>
                        </select>
                    </div>
                  
                    <div class="mobile-operator">
                        <label for="" class="payment-label">Select Mobile Operator</label>
                        <div class="operator-icons">
                            <button 
                                class="op-icons mtn-border" 
                                :class="{ 'selected': selectedNetwork === 'mtn' }" 
                                @click="select_network('MTN_24207', 'mtn')">
                                <img src="../assets/mtn.png" alt="">
                            </button>
                            <button 
                                class="op-icons glo-border" 
                                :class="{ 'selected': selectedNetwork === 'glo' }" 
                                @click="select_network('GLO_30387', 'glo')">
                                <img src="../assets/glo.png" alt="">
                            </button>
                            <button 
                                class="op-icons airtel-border" 
                                :class="{ 'selected': selectedNetwork === 'airtel' }" 
                                @click="select_network('AIRTEL_22689', 'airtel')">
                                <img src="../assets/airtel.png" alt="">
                            </button>
                            <button 
                                class="op-icons etisalat-border" 
                                :class="{ 'selected': selectedNetwork === 'etisalat' }" 
                                @click="select_network('9MOBILE_69358', 'etisalat')">
                                <img src="../assets/9mobile.png" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="payment-method">
                        <label for="" class="payment-label">Mobile Phone Number</label>
                        <input type="text" name="" id="" class="payment-input" placeholder="E.g. 08133516271" v-model="mobile_number" inputmode="numeric" pattern="[0-9]*" @keypress="onlyNumber($event)">
                    </div>
                    <div class="payment-method">
                        <label for="" class="payment-label">Airtime Amount</label>
                        <input type="text" name="" id="" class="payment-input" placeholder="E.g. 10000" v-model="airtime_amount" inputmode="numeric" pattern="[0-9]*" @keypress="onlyNumber($event)">
                        <div class="quick-option">
                            <span>QUICK OPTIONS</span>
                            <button class="quick-amount" :class="{ 'selected': quick_amount === '200' }"  @click="quick_option('200')">200</button>
                            <button class="quick-amount" :class="{ 'selected': quick_amount === '500' }" @click="quick_option('500')">500</button>
                            <button class="quick-amount" :class="{ 'selected': quick_amount === '1000' }" @click="quick_option('1000')">1000</button>
                        </div>
                    </div>
                    <div class="btn-panel">
                        <button class="btn-continue" @click="airtime_purchase()">Continue</button>
                        <button class="btn-cancel" @click="go_back()">Cancel</button>
                    </div>
                    
                </div>
              </div>
         </div>
         <div v-if="isConfirm">
            <transition name="modal">
                <div class="vcard-modal-mask">
                    <div class="modal-wrapper col-md-3" style="margin:auto">
                        <div class="row">
                            <div class="col-md-1">
                            </div>
                            <div class="col-md-10">
                                <div class="row d-flex flex-column align-items-center">
                                    <p class="text-black text-uppercase text-center mt-6">Enter your transaction pin</p>
                                    <div class="inputs1"> 
                                        <input type="password" maxlength="1" class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off"  v-model="verify_code1" required @input="moveToNext(1)" ref="input1" name="input1" id="input1" @keypress="onlyNumber($event)">
                                        <input type="password" maxlength="1" class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off" v-model="verify_code2" required @input="moveToNext(2)" ref="input2" name="input2" id="input2" @keypress="onlyNumber($event)">
                                        <input type="password" maxlength="1" class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off" v-model="verify_code3" required @input="moveToNext(3)" ref="input3" name="input3" id="input3" @keypress="onlyNumber($event)">
                                        <input type="password" maxlength="1"  class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off" v-model="verify_code4" required @input="moveToNext(4)" ref="input4" name="input4" id="input4" @keypress="onlyNumber($event)">
                                    </div>
                                
                                    <div class="btn-inputs">
                                        <button id="submit4" class="btn btn-primary btn-block mt-4 mb-4"  @click="airtime_data_purchase1()" v-if="!loading4">Confirm</button>
                                        <button class="btn btn-primary btn-block mt-4 mb-4" type="button" disabled v-if="loading4">
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        </button>
                                        <button class="btn btn-block" @click="isConfirm = false">X</button>
                                        <br>
                                    </div>     
                                </div>
                            </div>
                            <div class="col-md-1">
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
         </div>

         <div v-if="isPaymentModeModal">
            <transition name="modal">
                <div class="vcard-modal-mask">
                    <div class="modal-wrapper payment-mode-modal">
                        <button class="modal-close" type="button" @click="isPaymentModeModal = false" aria-label="Close modal">
                            &times;
                        </button>
                        <div class="payment-mode-header">
                            <div class="payment-mode-icon">
                                <i class="fa-solid fa-phone"></i>
                            </div>
                            <div>
                                <p class="payment-mode-kicker">Airtime payment</p>
                                <h3>Choose payment mode</h3>
                                <p class="payment-mode-copy">Select how you would like to complete this airtime purchase.</p>
                            </div>
                        </div>

                        <div class="payment-mode-summary">
                            <div class="summary-item">
                                <span>Phone number</span>
                                <strong>{{ mobile_number || 'N/A' }}</strong>
                            </div>
                            <div class="summary-item">
                                <span>Amount</span>
                                <strong>&#8358;{{ formatAmount(airtime_amount) }}</strong>
                            </div>
                            <div class="summary-item">
                                <span>Reference</span>
                                <strong>{{ order_reference || 'N/A' }}</strong>
                            </div>
                        </div>

                        <div class="payment-mode-actions">
                            <button
                                class="payment-mode-option wallet"
                                @click="choosePaymentMode('wallet')"
                                :disabled="paymentModeLoading"
                            >
                                <span class="option-icon"><i class="fa fa-wallet"></i></span>
                                <span class="option-copy">
                                    <strong>Wallet</strong>
                                    <small>Pay instantly from your wallet balance</small>
                                </span>
                                <span class="option-arrow"><i class="fa fa-chevron-right"></i></span>
                            </button>

                            <!-- <button
                                class="payment-mode-option bank"
                                @click="choosePaymentMode('bank')"
                                :disabled="paymentModeLoading"
                            >
                                <span class="option-icon"><i class="fa fa-building-columns"></i></span>
                                <span class="option-copy">
                                    <strong>Bank transfer</strong>
                                    <small>Continue to transfer instructions</small>
                                </span>
                                <span class="option-arrow"><i class="fa fa-chevron-right"></i></span>
                            </button> -->
                        </div>

                        <div class="payment-mode-footer">
                            <span>Your airtime order will stay reserved while you decide.</span>
                        </div>
                    </div>
                </div>
            </transition>
         </div>
          <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
  </template>
  <script>
  import swal from 'sweetalert2';
  import PageLoader from '../components/PageLoader.vue'
  export default {
    
    name: "AirtimeDataPage",
    components: {
      PageLoader
    },
  
    data(){
      return {
          search: '',
          loading: false,
          isLoading: false,
          loading4: false,
          user_id: '',
          firstname: '',
          lastname: '',
          bank_name:'',
          account_name:'',
          account_number: '',
          funding_amount: '',
          error: '',
          payment_reference: '',
          fullname: '',
          cpayment_method: 'regular-payment',
          utility_option: '',  
          service: '', 
          network: '',
          payment_method: '',
          mobile_number: '',
          airtime_amount: '',   
          purchase_mode: 'airtime',
          walletBal: '',
          quick_amount: '',
          dataList: [],
          is_plan_available: false,
          mobile_data: '',
          plan_name: '',
          verify_code: '',
          verify_code1: '',
          verify_code2: '',
          verify_code3: '',
          verify_code4: '',
          isConfirm: false,
          is_loading_tv: false,
          paymentModeLoading: false,
          isPaymentModeModal: false,
          order_reference: '',
          networks: {
            30: "MTN",
            37: "GLO",
            39: "Airtel",
            40: "Etisalat"
            },
          networkDetails: [],
          networkId: '',
          selectedNetwork: ''
        };
    },
  
    beforeMount(){
      this.user_id = localStorage.getItem("userid");
    },
  
    mounted(){
        
        this.firstname = localStorage.getItem("firstname");
        this.lastname = localStorage.getItem("lastname");
        this.phone_number = localStorage.getItem("phone");
        this.email_address = localStorage.getItem("email");
        this.user_id = localStorage.getItem("userid");
        this.fullname = this.firstname +'_'+ this.lastname 
        this.utility_option = 'airtime'
        this.purchase_mode = 'airtime'
    },
  
    created(){
          
    },
  
    computed: {
    
    },
  
    methods: {
        formatAmount(amount) {
            const value = Number(amount || 0);
            return value.toLocaleString('en-NG', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        onlyNumber(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        },
        switchPurchaseType() {
            if (this.purchase_mode === 'data') {
                if (this.$route.path !== '/data/purchase') {
                    this.$router.push('/data/purchase');
                }
                return;
            }

            if (this.$route.path !== '/airtime/purchase') {
                this.$router.push('/airtime/purchase');
            }
        },
        async fetch_user_pin(){
            try {
                const response = await this.$http.post('/fetch-pin', {
                    user_id: this.user_id
                })         
                this.user_pin = response.data.data

            } catch (err) {
                console.log(err);
            }
        },

        moveToNext(index) {
            const verifyCode = this[`verify_code${index}`];
            if (verifyCode.length === 1) {
                const nextIndex = index + 1;
                if (nextIndex <= 4) {
                    this.$refs[`input${nextIndex}`].focus();
                }
            }
        },
        handlePaste(event) {
        event.preventDefault(); // Prevent the default paste behavior
        const pasteData = event.clipboardData.getData('text');
        if (pasteData.length === 4) {
            this.verify_code1 = pasteData[0];
            this.verify_code2 = pasteData[1];
            this.verify_code3 = pasteData[2];
            this.verify_code4 = pasteData[3];

            // Move focus to the last input field
            this.$nextTick(() => {
            this.$refs.input4.focus();
            });
            }
        },

        async select_network(network, selectedNetwork){
             try{    

                this.network = network
                this.selectedNetwork = selectedNetwork || ''

                    // const response = await this.$http.post('/etransact/list-vtu-category', {
                    //     network: network,
                    // });
                    // this.networkDetails = response.data.data
                    this.networkId = network

                    return;              
                
            }catch (err) {
                console.log(err);
                swal.fire({
                icon: 'error',
                title: 'Error',
                width: 450,
                height: 5,
                text: err.response ? err.response.data.message : err.message,
            })
            }          
        },
        quick_option(option){
            this.airtime_amount = option
            this.quick_amount = option
        },
        async get_wallet_balance(){
            try{
                    const response = await this.$http.post('/fetch-wallet-balance', {
                        userid: this.user_id,
                    });
                    this.walletBal = response.data.balance
                    return;              
                    
            }catch (err) {
                console.log(err);
            }
       },

        validateInput(){
            const value = this.funding_amount;
            if (value < 0) {
            this.error = 'Value must be non-negative';
            this.funding_amount = ''
            return
            } else if (!Number.isInteger(Number(value))) {
            this.error = 'Value must be an integer';
            this.funding_amount = ''
            return
            } else {
            this.error = '';
            }
        },

        async airtime_purchase() {
            try {              
                localStorage.removeItem('paymentData'); // clear any stored payment data
                localStorage.removeItem('airtimeWalletPurchase');

                 // Validate fields
                if (!this.network) return this.showWarning("Please select mobile operator");
                if (!this.mobile_number) return this.showWarning("Please enter mobile number");
                if (!this.airtime_amount) return this.showWarning("Please enter airtime amount");

                this.loading4 = true;

                const { data } = await this.$http.post('/xpresspay/vtu-bill-payment-query', {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email_address: this.email_address,
                    phone: this.mobile_number,
                    amount: this.airtime_amount,
                    userid: this.user_id,
                    service_id: this.network,
                    payment_method: 'quick-payment',
                });

                if (!data.success) {
                    this.loading4 = false;
                    return this.showWarning(data.message);
                }

                this.order_reference = data.order_reference;
                this.loading4 = false;
                this.isPaymentModeModal = true;

            } catch (err) {
                console.log(err);
                this.loading4 = false;
                 swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    height: 5,
                    text: err.response ? err.response.data.message : err.message,
                })
            }
        },
        showWarning(message) {
            swal.fire({
                icon: "warning",
                title: "Warning",
                width: 450,
                text: message,
            });
        },
        buildWalletPurchasePayload() {
            const amount = Number(this.airtime_amount || 0);

        return {
            utility: this.utility_option,
            payment_amount: amount,
            amount,
            company_package: this.networkId || this.network,
            productId: this.networkId || this.network,
            company_name: this.networkDetails && this.networkDetails[0] ? this.networkDetails[0].billName : (this.network || 'Airtime'),
            meter_number: this.mobile_number,
            meter_type: this.network,
            order_reference: this.order_reference,
            service_fee: 0,
                customer_name: this.mobile_number,
                customer_id: this.mobile_number,
                createdAt: Date.now()
            };
        },
        choosePaymentMode(mode) {
            try {
                if (!this.order_reference) {
                    this.showWarning('Missing order reference for this purchase.');
                    return;
                }

                if (mode === 'bank') {
                    this.isPaymentModeModal = false;
                    this.$router.push(
                        `/bill-utility-payment/${this.utility_option}/${this.airtime_amount}/${this.network}/${this.mobile_number}/${this.order_reference}`
                    );
                    return;
                }

                if (mode === 'wallet') {
                    this.paymentModeLoading = true;
                    const payload = this.buildWalletPurchasePayload();
                    localStorage.setItem('airtimeWalletPurchase', JSON.stringify(payload));

                    this.$nextTick(() => {
                        this.paymentModeLoading = false;
                        this.isPaymentModeModal = false;
                        this.$router.push('/airtime-wallet-purchase');
                    });
                }
            } catch (err) {
                this.paymentModeLoading = false;
                console.log(err);
            }
        },
        async bank_transfer(){
            try {
                    if (!this.funding_amount) {
                    swal.fire({
                        icon: 'warning',
                        title: 'Warning',
                        width: 450,
                        height: 5,
                        text: 'Please enter amount to fund',
                    })
                    return;
                    }

                    this.loading = true
                    this.payment_reference = Date.now() % 100000
                    const full_name = this.firstname
                    const ref = full_name + '_' + this.payment_reference

                    if (this.cpayment_method == 'regular-payment') {

                    this.loading = false
                    this.$router.push('/bank-transfer/'+ref+'/'+this.funding_amount)
                    }
                    else if (this.cpayment_method == 'quick-payment') {
                    swal.fire({
                        icon: 'info',
                        title: 'Quick Payment!',
                        width: 450,
                        height: 5,
                        text: 'Not available at the moment',
                    })
                    this.loading = false
                    return;
                    }

                    this.loading = false

                } catch (err) {
                    console.log(err);
                }
            
        },

        go_back(){
            this.$router.push('/home')
        },
        
    }
  }
  </script>
  <style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
  .mtn-border {
    border: 2px solid transparent;
    padding: 5px;
    border-radius: 8px;
    transition: 0.3s ease;
    }

    .mtn-border.selected {
    border: 2px solid #ffcc00; /* MTN yellow */
    }
  .container-fluid{
  background: #cccccc41;
  border-radius: 10px;
  //padding: 0 40px 0 15rem;
  min-height: 100vh;
}
  .vcard-modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 18px;
    background: rgba(8, 18, 12, 0.62);
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity .4s ease;
  }
  .payment-mode-modal{
    position: relative;
    width: min(92vw, 520px);
    padding: 30px;
    border-radius: 24px;
    background:
      radial-gradient(circle at top right, rgba(36, 86, 43, 0.08), transparent 28%),
      linear-gradient(180deg, #ffffff 0%, #f7faf7 100%);
    border: 1px solid rgba(36, 86, 43, 0.14);
    box-shadow: 0 30px 90px rgba(0, 0, 0, 0.28);
    font-family: Poppins;
    overflow: hidden;
  }
  .payment-mode-modal::before{
    content: "";
    position: absolute;
    inset: 0 auto auto 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(90deg, #24562B 0%, #4c855b 52%, #9bc8a7 100%);
  }
  .modal-close{
    position: absolute;
    top: 14px;
    right: 14px;
    width: 34px;
    height: 34px;
    border: 0;
    border-radius: 999px;
    background: rgba(36, 86, 43, 0.08);
    color: #24562B;
    font-size: 26px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .payment-mode-header{
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 10px;
    padding-right: 28px;
  }
  .payment-mode-icon{
    width: 54px;
    height: 54px;
    flex: 0 0 54px;
    border-radius: 16px;
    background: linear-gradient(135deg, #24562B 0%, #3d7a49 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 24px rgba(36, 86, 43, 0.24);
  }
  .payment-mode-icon i{
    font-size: 20px;
  }
  .payment-mode-kicker{
    margin: 0 0 4px;
    font-size: 11px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #24562B;
    font-weight: 700;
  }
  .payment-mode-header h3{
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #172018;
    line-height: 1.15;
  }
  .payment-mode-copy{
    margin: 8px 0 0;
    font-size: 13px;
    color: #69736d;
    line-height: 1.5;
    max-width: 32ch;
  }
  .payment-mode-summary{
    margin-top: 22px;
    padding: 18px;
    border-radius: 18px;
    background: linear-gradient(180deg, #f6faf6 0%, #eef6ef 100%);
    border: 1px solid rgba(36, 86, 43, 0.10);
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.7);
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
  .summary-item{
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 12px 14px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.82);
    border: 1px solid rgba(36, 86, 43, 0.08);
  }
  .summary-item span{
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #7b847f;
    font-weight: 700;
  }
  .summary-item strong{
    font-size: 14px;
    color: #132017;
    word-break: break-word;
  }
  .payment-mode-actions{
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 18px;
  }
  .payment-mode-option{
    width: 100%;
    border: 1px solid #e3e9e4;
    border-radius: 18px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfcfb 100%);
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    text-align: left;
    min-height: 76px;
    box-shadow: 0 10px 24px rgba(15, 35, 18, 0.06);
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  }
  .payment-mode-option.wallet{
    border-color: rgba(36, 86, 43, 0.18);
  }
  .payment-mode-option.bank{
    border-color: rgba(14, 61, 102, 0.18);
  }
  .payment-mode-option:hover{
    transform: translateY(-1px);
    box-shadow: 0 14px 28px rgba(15, 35, 18, 0.09);
  }
  .payment-mode-option:disabled{
    opacity: 0.72;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 10px 24px rgba(15, 35, 18, 0.05);
  }
  .option-icon{
    width: 46px;
    height: 46px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #24562B;
    background: #f3f7f4;
    flex: 0 0 44px;
  }
  .payment-mode-option.wallet .option-icon{
    background: linear-gradient(135deg, rgba(36, 86, 43, 0.12), rgba(36, 86, 43, 0.06));
    color: #24562B;
  }
  .payment-mode-option.bank .option-icon{
    background: linear-gradient(135deg, rgba(14, 61, 102, 0.12), rgba(14, 61, 102, 0.06));
    color: #0e3d66;
  }
  .option-copy{
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .option-copy strong{
    font-size: 15px;
    color: #132017;
    line-height: 1.2;
  }
  .option-copy small{
    font-size: 12px;
    color: #7b847f;
    line-height: 1.4;
    margin-top: 4px;
  }
  .option-arrow{
    color: #7b847f;
    font-size: 12px;
    background: #f4f7f4;
    width: 30px;
    height: 30px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .payment-mode-footer{
    margin-top: 18px;
    font-size: 12px;
    color: #607068;
    text-align: center;
    padding: 10px 14px;
    border-radius: 999px;
    background: rgba(36, 86, 43, 0.05);
    border: 1px solid rgba(36, 86, 43, 0.08);
  }
  .inputs1{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    border-radius: 3px;
    font-size:11px;
    font-weight: 400;

    .inputs-field1{
        font-size: 14px;
        font-weight: bold;
        font-family: Poppins;
        text-align: center;
        height: 40px;
        width: 100%;
        margin: 5px;
        border: solid 1px;
    }
}
.btn-primary{
    width: 100%;
    height: 52px;
    padding: 0px 36.19px 0px 36.19px;
    border-radius: 9.05px;
    background: #24562B;
    color: #fff;
    text-transform: uppercase;
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 700;
}
  .error{
    color: #fff;
    font-size: 10px;
  }
  .copy-refid1{
    cursor: pointer;
    //font-size: 20px;
  }
   
  .welcome{
    font-family: Poppins;
    font-size: 18px;
    font-weight: normal;
    padding: 0px 20px;
    text-align: left;
    color: #170e0fac;
  }
   .dashboard-page{
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      background: transparent;
      padding: 0.6rem;
      font-family: Poppins;
      strong{
        font-weight: normal;
        font-family: Poppins;
      }
   }
 
   .dashboard-inner-new{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    padding: 18px 35px 18px 35px;
    gap: 10px;
    border-radius: 16px;
    border: 3px solid #F4F4F4;
    background: var(--White-Original, #FFFFFF);
   }
   .back-button{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 40px;
    border-radius: 102px;
    background: var(--Color-4, #D9D9D9);
    color: #fff;
   }
   .panel-title{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;

    .ptitle{
        //font-family: Montserrat;
        font-size: 17px;
        font-weight: 500;
        text-align: left;
    }
   }
   .airtime-data{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
   }
   .airtime{
    width: 140px;
    height: 45px;
    padding: 10px 39px 10px 39px;
    border-radius: 8px;
    border: 1px solid #24562B;
    background: #ECF3FF;
    color: #24562B;
    //font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
   }
   .airtime1{
    width: 140px;
    height: 45px;
    padding: 10px 39px 10px 39px;
    border-radius: 8px;
    background: #ECF3FF;
    color: #D9D9D9;

    //font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
   }
   .data{
    width: 140px;
    height: 45px;
    padding: 10px 39px 10px 39px;
    border-radius: 8px;
    border: 1px solid #24562B;
    background: #ECF3FF;
    color: #24562B;
     //font-family: Montserrat;
     font-size: 15px;
     font-weight: 500;
     text-align: center;
   }
   .data1{
    width: 140px;
    height: 45px;
    padding: 10px 39px 10px 39px;
    border-radius: 8px;
    background: #ECF3FF;
    color: #D9D9D9;
     //font-family: Montserrat;
     font-size: 15px;
     font-weight: 500;
     text-align: center;
   }
   .payment-method{
        display: flex;
        flex-direction: column;
        justify-content: left;
        //align-items: center;
   }
   .payment-label{
    //font-family: Montserrat;
    font-size: 12px;
    font-weight: 400;
    line-height: 17.07px;
    text-align: left;
    color:  #7F7F7F;
   }
   .payment-input{
    width: 100%;
    height: 45px;
    padding: 13px 18px 13px 18px;
    border-radius: 8px;
    background: #ECF3FF;
    color:  #7F7F7F;
   }
   .purchase-select{
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 42px;
    background-image: linear-gradient(45deg, transparent 50%, #7F7F7F 50%), linear-gradient(135deg, #7F7F7F 50%, transparent 50%);
    background-position: calc(100% - 20px) calc(50% - 3px), calc(100% - 14px) calc(50% - 3px);
    background-size: 6px 6px, 6px 6px;
    background-repeat: no-repeat;
   }
   .mobile-operator{
    display: flex;
    flex-direction: column;
    justify-content: left;
    }
    .operator-icons{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
    }
    
    .op-icons {
    width: 72px;
    height: 72px;
    padding: 8px;
    border: 2px solid #ddd;
    border-radius: 14px;
    background: #fff;
    transition: all 0.2s ease;
    cursor: pointer;
    margin: 5px;
    }

.op-icons img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Selected state overrides everything */
.op-icons.selected {
  border-width: 3px;
  box-shadow: 0 0 0 5px rgba(36, 86, 43, 0.18);
  transform: translateY(-2px);
  background: #fff;
 
}

/* Brand colors only visible when NOT selected */
.mtn-border    { border-color: #f7c70080; }
.glo-border    { border-color: #009f3f80; }
.airtel-border { border-color: #ff000080; }
.etisalat-border { border-color: #00c85380; }

/* When selected → use stronger brand color or a unified selected color */
.mtn-border.selected    { border-color: #f7c700; }
.glo-border.selected    { border-color: #009f3f; }
.airtel-border.selected { border-color: #ff0000; }
.etisalat-border.selected { border-color: #00c853; }
   
    .quick-option{
        display: flex;
        flex-direction: row;
        justify-content: right;
        align-items: center;
        color:  #7F7F7F;
        font-size: 13px !important;
       // font-weight: 400;
       .quick-amount{
            width: 65px;
            height: 28px;
            padding: 5px 13px 5px 13px;
            border-radius: 8px;
            margin: 4px;
            background: #ECF3FF;
            border: 1px solid #E8EBF0;
        }
       
    }
    .quick-amount.selected {
        border-color: #24562B; /* Change to your desired border color */
    }
    .btn-panel{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
   
    .btn-continue{
        width: 300px;
        height: 52px;
        padding: 0px 36.19px 0px 36.19px;
        border-radius: 9.05px;
        background: #24562B;
        color: #fff;
        text-transform: uppercase;
        font-family: Montserrat;
        font-size: 15px;
        font-weight: 700;
    }
    .btn-cancel{
        width: 300px;
        height: 52px;
        padding: 0px 36.19px 0px 36.19px;
        border-radius: 9.05px;
        background: #fff;
        color: #000;
        text-transform: uppercase;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 300;
        line-height: 17.07px;

    }

  
  @media screen and (max-width: 768px) {
    .payment-mode-modal{
      width: min(94vw, 460px);
      padding: 22px 18px;
      border-radius: 18px;
    }
    .payment-mode-header{
      align-items: flex-start;
      gap: 12px;
      padding-right: 24px;
    }
    .payment-mode-icon{
      width: 48px;
      height: 48px;
      flex-basis: 48px;
      border-radius: 14px;
    }
    .payment-mode-header h3{
      font-size: 19px;
    }
    .payment-mode-summary{
      grid-template-columns: 1fr;
    }
    .summary-item{
      padding: 11px 12px;
    }
    .payment-mode-option{
      padding: 14px;
      min-height: 70px;
    }
    .container-fluid{
        padding: 0 0px 0 0rem;
    }
    .welcome{
      font-family: Poppins;
      font-size: 16px;
      font-weight: 700;
      padding: 0px 15px;
      text-align: left;
      color: #170e0fac;
    }
  
    .dashboard-page{
      display: flex;
      flex-direction: column;
      strong{
        margin-top: 10px;
      }
   }
   .dashboard-inner{
    margin: 0px;
    margin-top: 10px;
    padding: 0.8rem;
   }
   .inputs1{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    border-radius: 3px;
    font-size:11px;
    font-weight: 400;

    .inputs-field1{
        font-size: 14px;
        font-weight: bold;
        font-family: Poppins;
        text-align: center;
        height: 40px;
        width: 50px;
        margin: 5px;
        border: solid 1px;
    }
}
   .dashboard-inner-new{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    padding: 0.6rem;
    gap: 10px;
    border-radius: 16px;
    
    border: 3px solid #F4F4F4;
    background: var(--White-Original, #FFFFFF);
   }
   .quick-option{
    font-size: 11px !important;
    span{
        width: 100%;
    }
   button{
        width: 60px;
        padding: 0px 10px 0px 10px;
        border-radius: 8px;
        margin: 3px;
        }
    }
    
    .btn-continue{
        width: 100%;
        font-size: 13px;
    }
    .btn-cancel{
        width: 100%;;
        font-size: 13px;
    }
    
  }
  
  </style>
